import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';

const copy = d => JSON.parse(JSON.stringify(d));

class CreateContact extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'CreateContact';
    this.state = {
      create : false,
      contact : { name : '', phone : '', notes : ''}
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.reset = this.reset.bind(this);
  }
  handleChange(event) {
    let { contact } = copy(this.state);
    const { name, value } = event.target;
    contact[name] = value;
    this.setState({ contact });
  }
  handleSave() {
    this.props.createContact({ ...this.state.contact, client : this.props.client });
  }
  reset() {
    this.setState({ contact : { name : '', phone : '', notest : '' }, create : false });
  }
  componentWillUpdate(nextProps) {
    if(this.props.creating_contact && !nextProps.creating_contact && nextProps.create_success) {
      this.reset();
    }
  }
  render() {
    const { create , contact } = this.state;
    const { creating_contact } = this.props;

    return(
      <div>
        {creating_contact ? (
          <div><i className="fa fa-spinner fa-spin"></i> Creating contact...</div>
        ) : create ? (
          <div className="row">
            <div className="col-xs-12 mb-sm">
              <span className="input-group mb-sm">
                <span className="input-group-addon"><i className="fa fa-user"></i></span>
                <input onChange={this.handleChange} className="form-control" type="text" name="name" placeholder="Enter name." value={contact.name} />
              </span>
              <span className="input-group mb-sm">
                <span className="input-group-addon"><i className="fa fa-phone"></i></span>
                <input onChange={this.handleChange} className="form-control" type="text" name="phone" placeholder="Enter phone." value={contact.phone} />
              </span>
              <span className="input-group">
                <span className="input-group-addon"><i className="fa fa-sticky-note-o"></i></span>
                <span className="message truncate"><input onChange={this.handleChange} className="form-control" type="text" name="notes" placeholder="Enter notes." value={contact.notes} /></span>
              </span>
            </div>
            <div className="col-xs-12 col-md-6">
              <div onClick={this.reset} className="btn btn-block btn-default">Cancel</div>
            </div>
            <div className="col-xs-12 col-md-6">
              <div onClick={this.handleSave} className="btn btn-block btn-success">Save</div>
            </div>
          </div>
        ) : (
          <div onClick={f => this.setState({create : true})} className="btn btn-block btn-default"><i className="fa fa-plus"></i> Add Contact</div>
        )}
      </div>
    )
  }
}

CreateContact.propTypes = {
  client : PropTypes.string.isRequired
}

const mapStateToProps = ({ contacts }) => ({ ...contacts });

export default connect(mapStateToProps, Actions)(CreateContact);



// WEBPACK FOOTER //
// ./src/browser/components/client/contacts/create-contact.js